export const apiConfig = {
  // Prefer env so we can swap between test/prod without code changes
  BASE_URL: process.env.REACT_APP_API_BASE_URL
    || 'https://wabb-service-652532757120.europe-west1.run.app',
  // Optionally, allow an explicit ping path if the function is not at root
  PING_PATH: process.env.REACT_APP_API_PING_PATH || '/ping',

  // Firebase Configuration (use environment variables in production)
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
  },

  // API Endpoints
  endpoints: {
    register: '/api/register',
    contact: '/api/contact',
    subscribe: '/api/subscribe'
  },

  // External Services
  services: {
    stripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    googleAnalyticsId: process.env.REACT_APP_GA_ID,
    hotjarId: process.env.REACT_APP_HOTJAR_ID
  }
};

export default apiConfig;
